// 重置浏览器样式
import '$common/style/reset.styl';
import boot from '$boot/boot';
import pageComponent from './index';
import DocumentTitlePlugin from '$common/utils/vue-plugin/document-title';
import DocumentMixin from '$common/utils/vue-plugin/mixins/document-mixin';
import ToolMixin from '$common/utils/vue-plugin/mixins/tool-mixin';
import TecalcMixin from '$common/utils/vue-plugin/mixins/recalc-mixin';
import { Statistics } from '$superAppUser/util/statistics';
import routerModule from './router'
import language from './language';
import store from './store'
import Vue from 'vue';
Vue.use(DocumentTitlePlugin)
Vue.use({
  install(__Vue) {
    const __timeout = setTimeout(() => {
      clearTimeout(__timeout);
      __Vue.prototype.$Statistics = Statistics;
    }, 3000);
  }
})
try {
  //  将后端渲染的东西序列化成对象
  window.ssrConfig = JSON.parse(decodeURIComponent(window.ssrConfig));
} catch (err) {}

const { i18n, loadLanguageAsync } = language.use(Vue, VueI18n)
const router = routerModule.use(Vue, VueRouter, loadLanguageAsync)

boot({
  Vue,
  pageComponent,
  before: config => Object.assign({}, config, {
    i18n,
    router,
    mixins: [ToolMixin, DocumentMixin, TecalcMixin, store]
  }),
  after: vm => {
    //  监听语言切换，动态懒加载国际化文案
    vm.$watch('$i18n.locale', lang => loadLanguageAsync({
      lang
    }).then().catch(() => {
      vm.$router.push({
        name: '/*'
      })
    }));
  }
});